import React from "react"

const OrganizationContext = React.createContext({})

export default OrganizationContext
